import type { DiseaseScore } from '@greeniq/shared';
import { api } from './client.js';

export interface DiseaseCurrentResponse {
  scores: DiseaseScore[];
}

export interface DiseaseHistoryResponse {
  history: DiseaseScore[];
  days: number;
}

export function getCurrentDiseaseRisk(courseSlug: string): Promise<DiseaseCurrentResponse> {
  return api.get<DiseaseCurrentResponse>(`/courses/${courseSlug}/disease/current`);
}

export function getDiseaseHistory(
  courseSlug: string,
  days = 30,
): Promise<DiseaseHistoryResponse> {
  return api.get<DiseaseHistoryResponse>(
    `/courses/${courseSlug}/disease/history?days=${days}`,
  );
}
